import { Modal } from "react-bootstrap";
import { Wrapper, Button, Refund } from "../styles";
import { convertDate, hasReturnWindowExpired, renderSizeAbbreviationHTML } from "../utils";
import { downloadReturnLabel } from "../api/order";
import toast from "react-hot-toast";
import { ASSET_URL } from "../constants";

export const ViewReturnsTemplate = ({ currentOrder }) => {
  let returnTotal = 0;

  const renderReturns = () => {
    return currentOrder?.returns.map((returnObj) => {
      returnTotal = returnTotal + returnObj.refundAmount;
      return <Refund>{renderProducts(returnObj)}</Refund>;
    });
  };

  const getLabel = async (label) => {
    try {
      const url = await downloadReturnLabel(label);
      if (url) {
        window.open(url, "_blank");
      } else {
        toast.error("Couldn't find return label.");
      }
    } catch (err) {
      toast.error(err.message);
      console.log(err);
    }
  };

  const renderProducts = (returnObj) => {
    const returnWindowExpired = hasReturnWindowExpired(currentOrder.updatedAt);

    const filteredProducts = returnObj.products.filter((product) => {
      return product.returnType !== "Keep";
    });
    const products = filteredProducts.map((product) => {
      return (
        <div className="return-product" key={product.itemId}>
          <div className="products-view-image product-image border">
            <picture>
              <source srcset={`${ASSET_URL}/designs/small/${product.design}-logo.avif`} type="image/avif" />
              <img src={`${ASSET_URL}/designs/small/${product.design}-logo.gif`} width="110" />
            </picture>
          </div>
          <div className="products-view-details">
            <div>
              <div>
                <span>Return Type</span>
                <strong>{product.returnType}</strong>
              </div>
              <div className="return-details-margin-top">
                <span>Original Size</span>
                <strong className="size-badge" dangerouslySetInnerHTML={{ __html: renderSizeAbbreviationHTML(product.size) }} />
              </div>
              <div>
                <span>Original Position</span>
                <strong>{product.position}</strong>
              </div>
            </div>
            <div>
              {product.returnType === "Refund" ? (
                <div className="return-details-margin-top">
                  <span>Item Cost</span>
                  <strong>${product.productCost}</strong>
                </div>
              ) : (
                <>
                  <div className="return-details-margin-top">
                    <span>Exchange Size</span>
                    <strong dangerouslySetInnerHTML={{ __html: renderSizeAbbreviationHTML(product.sizeExchange) }} />
                  </div>
                  <div>
                    <span>Exchange Position</span>
                    <strong>{product.positionExchange}</strong>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      );
    });
    return (
      <>
        <div className="return-products">{products}</div>
        <div className="return-details">
          <div>
            Return Date
            <br />
            <span>{convertDate(returnObj.createdAt)}</span>
          </div>
          {returnObj.totalSalesTaxRefund > 0 && (
            <div>
              + Sales Tax Refund
              <br />
              <span>${returnObj.totalSalesTaxRefund.toFixed(2)}</span>
            </div>
          )}
          {returnObj.shippingFee > 0 && (
            <div>
              - Return Shipping Fee
              <br />
              <span>${returnObj.shippingFee.toFixed(2)}</span>
            </div>
          )}
          {returnObj.refundAmount > 0 && (
            <div>
              = Refund Amount
              <br />
              <span>${returnObj.refundAmount.toFixed(2)}</span>
            </div>
          )}
          {returnObj.returnLabel && !returnWindowExpired && (
            <div className="return-label">
              <Button onClick={() => getLabel(returnObj.returnLabel)} className="small grey">
                Return Label
              </Button>
            </div>
          )}
        </div>
      </>
    );
  };

  return (
    <Wrapper className="modal-styles withPadding return-view">
      <Modal.Header closeButton>
        <Modal.Title>Order # {currentOrder.orderNumber}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{renderReturns()}</div>
        {returnTotal > 0 && (
          <>
            <div className="return-bottom-bar">
              <span className="text">Total Refund Amount for this Order</span>
              <span className="amount">${returnTotal.toFixed(2)}</span>
            </div>
            <p style={{ marginTop: "20px", fontStyle: "italic", padding: "0 20px", textAlign: "center" }}>
              <strong>1 Free Return Per Order</strong>
              <br />
              One free return allowed per order. Additional returns are subject to a shipping fee.
            </p>
          </>
        )}
      </Modal.Body>
    </Wrapper>
  );
};
